(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/iam-idp/assets/javascripts/prescript.js');

'use strict';

svs = svs || {};
svs.iam_idp = svs.iam_idp || {};
svs.iam_idp.data = svs.iam_idp.data || {};
svs.iam_idp.constants = svs.iam_idp.constants || {};
svs.iam_idp.utils = svs.iam_idp.utils || {};
svs.iam_idp.dialogs = svs.iam_idp.dialogs || {};
svs.iam_idp.atoms = svs.iam_idp.atoms || {};
svs.iam_idp.components = svs.iam_idp.components || {};
svs.iam_idp.components.bank_id = svs.iam_idp.components.bank_id || {};
svs.iam_idp.components.freja = svs.iam_idp.components.freja || {};
svs.iam_idp.components.shared = svs.iam_idp.components.shared || {};
svs.iam_idp.components.media_queries = svs.iam_idp.components.media_queries || {};
svs.iam_idp.components.footer = svs.iam_idp.components.footer || {};
svs.iam_idp.logger = new svs.core.log.Logger('module:iam-idp');

 })(window);